import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';

import { GoogleAnalyticsService } from '@common/services/google-analytics/google-analytics.service';
import { AnalyticsActions } from '@common/services/google-analytics/models/analytics-actions.model';
import { AnalyticsFeatureTypes } from '@common/services/google-analytics/models/analytics-feature-types.model';
import { AnalyticsFeatures } from '@common/services/google-analytics/models/analytics-features.model';
import { AppVersionService } from '@common/services/app-version.service';

@Component({
  selector: 'app-version-banner',
  templateUrl: './app-version-banner.component.html',
  styleUrls: ['./app-version-banner.component.less'],
  standalone: true,
  imports: [AsyncPipe, NgIf]
})
export class AppVersionBannerComponent {
  private readonly appVersionService = inject(AppVersionService);
  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);

  readonly isUpdateAvailable$ = this.appVersionService.isUpdateAvailable$;

  reload(): void {
    void this.googleAnalyticsService.sendClickData({
      feature: AnalyticsFeatures.AppVersionBanner,
      action: AnalyticsActions.Reload,
      type: AnalyticsFeatureTypes.Banner
    });
    this.appVersionService.reload();
  }
}
